import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PostProjectFormFields {

    public name: FormField
    public description: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          true,
        )
        this.description = new FormField(
          'description',
          'Description',
          null,
          FormFieldType.text,
          true,
          true,
          ""
        )

    }
}

const fields = new PostProjectFormFields()

export const postProjectFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  description: fields.description,
};